
<ng-container *ngIf="isLoaded">
  <div class="modal-close-btn" (click)="closeModal()">X</div>
  <div class="card mb-3">
    <div class="card-body">
      <div class="pt-4 pb-2">
        <h5 class="card-title text-center pb-0 fs-4">Редакция на услуга за Доставчик</h5>
        <p class="text-center small">Моля, направете нужните промени</p>
      </div>

      <form [formGroup]="Form" class="row g-3 needs-validation" (ngSubmit)="onSubmit()">
        <div class="col-12">
          <label for="title" class="form-label">Име</label>
          <input type="text" formControlName="title" class="form-control" id="title">
        </div>
        <div class="col-12">
          <label for="agentCommission" class="form-label">Комисионна</label>
          <input type="text" formControlName="agentCommission" class="form-control" id="agentCommission">
        </div>
        <div class="col-12">
          <app-bank-selector [selectedBankDetails]="editObject.bankDetails" (selectedAccount)="onBankAccountSelected($event)" />
        </div>
        <div class="col-12">
          <label for="service" class="form-label">Услуга</label>
          <select formControlName="service" class="form-select">
            <option *ngFor="let service of services"
                    value="{{service.idService}}"
                    [selected]="isSelected(service)">
              {{service.serviceName}}
            </option>
          </select>
        </div>
        <div class="col-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="isActive" id="isActive">
            <label class="form-check-label" for="isActive">Активен</label>
          </div>
        </div>
        <div class="col-12">
          <button class="btn btn-primary w-100" type="submit" [disabled]="!Form.valid">Промени</button>
        </div>
      </form>
    </div>
  </div>

</ng-container>
